export function normalizeId(s) {
  return (s || '')
    .toString()
    .toLowerCase()
    .replace(/[-_\s]+/g, '')
    .trim()
}

export function findMatchingCategory(csData = {}, rawCatalogId = '') {
  const target = normalizeId(rawCatalogId)
  if (!target) return { matched: false }

  const topNav = csData?.top_navigation || []
  for (const navItem of topNav) {
    const references = navItem?.reference || []
    for (const ref of references) {
      const tn = ref?.top_navigation || []
      for (const tnItem of tn) {
        const catWrapper = tnItem?.category
        if (!catWrapper) continue
        const categories = Array.isArray(catWrapper.category)
          ? catWrapper.category
          : []
        for (const cat of categories) {
          const catCandidates = [
            cat?.category_id || '',
            cat?.uid || '',
            cat?.seo_information?.slug || '',
          ]
          if (catCandidates?.map(normalizeId)?.includes(target)) {
            const imgs = Array.isArray(cat?.image)
              ? cat?.image
              : cat?.image
                ? [cat?.image]
                : []
            const heroImageUrl = imgs[0]?.derivatives?.transformBaseUrl || null
            return {
              matched: true,
              isSubcategory: false,
              object: cat,
              heroImageUrl,
            }
          }

          if (Array.isArray(cat?.subcategories)) {
            for (const sub of cat?.subcategories) {
              const subCandidates = [
                sub?.category_id || '',
                sub?.uid || '',
                sub?.seo_information?.slug || '',
              ]
              if (subCandidates?.map(normalizeId)?.includes(target)) {
                const imgs = Array.isArray(sub?.image)
                  ? sub?.image
                  : sub?.image
                    ? [sub?.image]
                    : []
                const heroImageUrl =
                  imgs[0]?.derivatives?.transformBaseUrl || null
                return {
                  matched: true,
                  isSubcategory: true,
                  object: sub,
                  heroImageUrl,
                }
              }
            }
          }
        }
      }
    }
  }

  return { matched: false }
}

//src/utils/contentStackMatcher.js
